import {
  Component,
  ViewChild,
  TemplateRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  CompanyNavPageDataService,
  NAV_LOG_ACTION_FEATURES,
  NAV_PAGE,
} from "../company-nav-page-data.service";
import { VAIconRegistryService, fileExcel } from "@va/core-library/icons";
import {
  faTimes,
  faCheck,
  faTimesCircle,
  faInfoCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-company-nav-grid-controls",
  templateUrl: "./company-nav-grid-controls.component.html",
  styleUrls: ["./company-nav-grid-controls.component.scss"],
})
export class CompanyNavGridControlsComponent {
  @Output() dataSettingsChanged: EventEmitter<any> = new EventEmitter();
  @Output() getSourcesInfo = new EventEmitter();
  @Input() savedSettings;
  @Input() metaInfo;
  @Input() ticker;
  optionsSet: boolean = false;
  dataView: { view_by: any[]; revision: string } = {
    view_by: [],
    revision: "",
  };
  dataViewChanged = {
    view_by: [],
    revision: "",
  };
  //Currency filter
  selectedCurrency = "Base";
  currencyDisabled = false;
  apiEP: string = window.apiUrl;
  customSourcesDropdown;
  customCC: Array<any> = [];
  assets = window.assetUrl;
  showHighLow: boolean = true;
  defaultFiltersSet: boolean = false;
  metaError = false;
  isExportPopoverVisible = false;
  isExportInProgress: boolean = false;

  //excel export
  excelToExportDropdownOptions = [
    {
      label: "Values",
      id: 1,
      disabled: false,
    },
    {
      label: "Excel Add-In Formulas",
      id: 0,
      disabled: true,
    },
  ];

  //icons
  faTimes = faTimes;
  faCheck = faCheck;
  faTimesCircle = faTimesCircle;
  faInfoCircle = faInfoCircle;

  //snackbar
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };

  constructor(
    private iconRegistry: VAIconRegistryService,
    private dataService: CompanyNavPageDataService,
    private snackBar: MatSnackBar,
    private appService: AppService,
  ) {
    this.iconRegistry.registerIcons([fileExcel]);
  }

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.metaInfo && changes.metaInfo.currentValue) {
      if (changes.metaInfo.currentValue.status === "error") {
        this.defaultFiltersSet = true;
        this.metaError = true;
      } else if (
        changes.metaInfo.currentValue.currencyChanged &&
        this.defaultFiltersSet
      ) {
        return;
      } else if (
        changes.metaInfo.currentValue.user_settings &&
        changes.metaInfo.currentValue.user_settings.keyChanged
      ) {
        this.metaError = false;
        // set grid control options as saved
        this.setSavedOptions();
      } else if (
        changes.metaInfo.currentValue.sources_info &&
        changes.metaInfo.currentValue.sources_info.length > 0
      ) {
        this.metaError = false;
        // set grid control options as saved
        this.setDefaultOptions();
      } else if (
        changes.metaInfo.currentValue.sources_info &&
        changes.metaInfo.currentValue.sources_info.length === 0
      ) {
        this.metaError = false;

        this.selectedCurrency = "Base";
        this.dataView = {
          view_by: ["values"],
          revision: "",
        };
        this.defaultFiltersSet = true;
      }

      //this.setSavedOptions();
    }
  }

  setSavedOptions() {
    //set all options
    this.setCustomSources(this.metaInfo.sources_info);
    this.selectedCurrency = this.metaInfo.user_settings.currency || "Base";
    if (this.metaInfo.user_settings.view_by.length > 0) {
      this.dataView = {
        view_by: [...this.metaInfo.user_settings.view_by],
        revision: this.metaInfo.user_settings.revision,
      };
    } else {
      this.dataView = {
        view_by: ["values"],
        revision: "",
      };
    }
    this.dataViewChanged = {
      view_by: [...this.dataView.view_by],
      revision: this.dataView.revision,
    };
    this.showHighLow = this.metaInfo.user_settings.showHighLow;

    this.defaultFiltersSet = true;
  }

  setDefaultOptions() {
    this.setCustomSources(this.metaInfo.sources_info);
    this.selectedCurrency = "Base";
    this.dataView = {
      view_by: ["values"],
      revision: "",
    };
    this.dataViewChanged = {
      view_by: [...this.dataView.view_by],
      revision: this.dataView.revision,
    };
    this.defaultFiltersSet = true;
  }

  setCustomSources(sourceList) {
    const dropdownList = [];
    const excludedSpan = `  <img
    class="pad-icon"
    src="${this.assets}/icon-excluded.png"
    title="Excluded from consensus"
  />`;
    const selectedSources =
      this.metaInfo.user_settings.customCC &&
      this.metaInfo.user_settings.customCC.length > 0
        ? this.metaInfo.user_settings.customCC
        : [];
    this.customCC = [...selectedSources];
    sourceList.forEach((sourceObj) => {
      const obj = {
        label: sourceObj.source_name,
        labelHTML: "",
        value: sourceObj.sid.toString(),
        checked: selectedSources.includes(sourceObj.sid),
      };
      if (sourceObj.excluded) {
        obj.labelHTML = sourceObj.source_name + excludedSpan;
      }
      dropdownList.push(obj);
    });
    this.customSourcesDropdown = {
      headerText: "Custom Consensus",
      maxLimit: 15,
      list: [...dropdownList],
    };
  }
  updateDataView($event) {
    this.dataViewChanged = {
      view_by: $event.viewBy,
      revision: $event.revision,
    };
    this.emitOutput("revision");
  }

  updateSourcesInfo($event) {
    const view_by = $event.view_by;
    const rev_date = $event.rev_date;
    const masterparameter_dict = this.metaInfo["masterparameter_dict"];
    const defaultSource = this.metaInfo["default_source"];
    this.getSourcesInfo.emit({
      view_by,
      rev_date,
      masterparameter_dict,
      defaultSource,
    });
  }

  resetDataCallFlagInMetaInfo($event) {
    const { prevViewBy, prevRevDate, view_by, rev_date, source_updated } =
      $event;
    this.metaInfo["makeDataCall"] = false;
    this.metaInfo["prevViewBy"] = prevViewBy;
    this.metaInfo["prevRevDate"] = prevRevDate;
    this.metaInfo["view_by"] = view_by;
    this.metaInfo["rev_date"] = rev_date;
    this.metaInfo["source_updated"] = source_updated;
  }

  customConsensusChange($event) {
    const selectedSources = $event.map((sourceId) => parseInt(sourceId, 10));
    this.customCC = [...selectedSources];
    this.emitOutput("customCC");
    this.metaInfo.user_settings["customCC"] = this.customCC;
  }
  updateCCCheckbox(selectedSources) {
    this.customSourcesDropdown.list.forEach((val) => {
      if (selectedSources.includes(val.value)) val.checked = true;
      else val.checked = false;
    });
    this.customSourcesDropdown.list = [...this.customSourcesDropdown.list];
  }
  onHighLowSwitchChange(switchState: boolean) {
    // show hide high low
    this.showHighLow = switchState;
    this.metaInfo.user_settings["showHighLow"] = this.showHighLow;
    this.emitOutput("highLow");
  }
  onCurrencyChange(currency) {
    this.selectedCurrency = currency;
    this.emitOutput("currency");
  }

  emitOutput(keyChanged) {
    this.metaInfo["updatedKey"] = keyChanged;
    this.metaInfo.user_settings["keyChanged"] = keyChanged;
    const savedSettings = {
      currency: this.selectedCurrency === "Base" ? "" : this.selectedCurrency,
      view_by: [...this.dataViewChanged.view_by],
      revision: this.dataViewChanged.revision,
      customCC: this.customCC,
      showHighLow: this.showHighLow,
      keyChanged: keyChanged,
    };
    // save api call here
    //this.dataService.saveSettings(savedSettings)
    this.dataSettingsChanged.emit(savedSettings);
  }

  handleETEListItemClick(exportType) {
    if (exportType === 1) {
      this.isExportInProgress = true;
      this.dataService.navExport(this.ticker).subscribe(
        (res) => {
          if (res["status"] === "success") {
            this.isExportInProgress = false;
          } else {
            this.isExportInProgress = false;
            this.snackbarInfo.message = "NAV export couldn't be downloaded.";
            this.snackbarInfo.type = "failure";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }
          this.isExportPopoverVisible = false;
        },
        (err) => {
          this.isExportInProgress = false;
          console.error(err);
        },
      );

      this.appService.logUserAction(
        {},
        this.ticker,
        "",
        NAV_LOG_ACTION_FEATURES.valueOnlyExport,
        {},
        "",
        NAV_PAGE,
      );
    }
  }

  /**
   * Set the snackbar message and snackbarRef
   */
  showSnackBarToastMessage(info) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type);
  }

  /**
   * Hides the snack bar
   */
  dismissSnackBar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }

  /**
   * Shows snackbar message, according to (success | info | failure) template
   * @param {object} type - type of message (success | info | failure)
   */
  getSnackbarRef(type) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
    };
    if (typeMap[type]) {
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: 5000,
        verticalPosition: "top",
      });
    }
    return undefined;
  }
}
